export default {
  banners: {
    findOutMore: 'Find out more',
    stockTwits:
      'Want to learn how to place a trade or how trading tokenized stocks works? → {learnMore}',
    deprecatedWallet:
      'This wallet is depreciated. Follow the migration guide to move your funds. {learnMore}',
    deprecatedWalletWithAddress:
      'This wallet is depreciated. Your new SSO address is {address}. Follow the migration guide to move your funds. {learnMore}',
    postOnly:
      'Post-only mode active: Following the recent chain upgrade, new limit orders can be placed, but market orders and instant matches are unavailable for 2000 blocks. {link}',
    settlePerpMarketBanner:
      'There is currently a governance proposal to force settle this market. You are encouraged to close open positions, or you will be force liquidated at the mark price at the time of settlement.',
    pointsS1Ended:
      'Helix Points Season 1 has wrapped up. Thank you for your participation, and stay tuned for more updates!',

    kado: {
      getStarted: 'Get started',
      title: 'Introducing Helix 2.0! Discover a whole new trading experience.'
    },

    iAssets: {
      title: 'Trade iAssets on Helix',
      description:
        'Trade stocks with crypto for faster, cheaper, and more transparent transactions - combining traditional markets with the power of decentralized finance.'
    },

    userFeedback: {
      threeMinutes: '3 minutes ',
      notRightNow: 'Not right now',
      takeSurvey: 'Take the survey',
      loveFeedback: "We'd love to hear your feedback!",
      thankYouEnd:
        'to complete and the information will help us know how to improve your future experience on Helix.',
      thankYouBeginning:
        'Thank you for using Helix. We are constantly improving our products for our users and we’d love to hear from you! The survey should take fewer than '
    },

    newFeature: {
      cta: 'Trade TradFi',
      title: 'Introducing the TradFi Stocks Index!',
      description:
        'Trade the largest publicly traded stocks on-chain via one integrated index for the first time. Access TradFi 24/7 with the lowest fees and up to 25X leverage only on Helix.'
    },

    leaderboard: {
      currentCompetitionLink: '$50K prize pool on Helix!',
      currentCompetitionTitle:
        'Trade on Helix and compete for your share of a {linkDescription}',

      gwagon: {
        blog: 'blog',
        ended: 'Ended',
        title: 'Trade Like a G',
        description:
          'Trade for a chance to win a G-Wagon! From October 1st at 14:00 UTC to October 22nd at 14:00 UTC, trade for your chance to claim one of two G-Wagons—one for the top PnL trader and another for a lucky giveaway winner. Every $10 in trading volume earns an entry. For more details, visit the {blog}.'
      },
      tesla: {
        blog: 'blog',
        ended: 'Ended',
        title: 'Win a Tesla!',
        description:
          'Trade for a chance to win a Tesla! From November 26th at 15:00 UTC to December 6th at 15:00 UTC, the top trader by PnL will win a Tesla Model 3. For more details, visit the {blog}.'
      },
      ownYourAsset: {
        blog: 'blog',
        ended: 'Ended',
        title: 'Own Your Assets, Control Your Future.',
        description:
          'Compete for your share of a $50K prize pool on Helix. From February 21st, 2025 at 6pm UTC to March 3rd, 2025 at 6pm UTC, you can trade for a chance to win $1,000 from a $50k prize pool, through a random draw. Every $1,000 in trading volume earns an entry. For more details, visit the {blog}'
      }
    }
  }
}
